import {
  DashboardFilled,
  SettingFilled,
  SmileFilled,
  VideoCameraFilled,
} from "@ant-design/icons";
import { Menu } from "antd";
import Sider from "antd/lib/layout/Sider";
import SubMenu from "antd/lib/menu/SubMenu";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { SideContext } from "../../state/SideContext";

const Sidebar = () => {
  const { sideIndex } = useContext(SideContext);

  return (
    <Sider
      width={200}
      className="site-layout-background"
      breakpoint="lg"
      collapsedWidth="0"
    >
      <Menu
        mode="inline"
        defaultSelectedKeys={["dashboard"]}
        activeKey={sideIndex}
        selectedKeys={[sideIndex]}
        style={{ height: "100%", borderRight: 0 }}
      >
        <Menu.Item key="dashboard" icon={<DashboardFilled />}>
          <Link to="/admin/dashboard">Dashboard</Link>
        </Menu.Item>
        <SubMenu key="movies-menu" icon={<VideoCameraFilled />} title="Movies">
          <Menu.Item key="add-movie">
            <Link to="/admin/add-movie">Add Movie</Link>
          </Menu.Item>
          <Menu.Item key="all-movies">
            <Link to="/admin/all-movies">All Movies</Link>
          </Menu.Item>
        </SubMenu>
        <SubMenu key="games-menu" icon={<SmileFilled />} title="Games">
          <Menu.Item key="add-game">
            <Link to="/admin/add-game">Add Game</Link>
          </Menu.Item>
          <Menu.Item key="all-games">
            <Link to="/admin/all-games">All Games</Link>
          </Menu.Item>
        </SubMenu>
        <Menu.Item key="change-password" icon={<SettingFilled />}>
          <Link to="/admin/change-password">Change Password</Link>
        </Menu.Item>
      </Menu>
    </Sider>
  );
};

export default Sidebar;
